import {useSelector} from 'react-redux';

const useLoadingState = (eidParam?: string | undefined, pidParam?: string | undefined) => {
    const event = useSelector((s: any) => ({
        eid: s.event.eid,
        getEventXHR: s.event.getEventXHR
    }));

    const account = useSelector((s: any) => ({
        pid: s.account.pid,
        getAccountUserPermissionsXHR: s.account.getAccountUserPermissionsXHR,
        getAccountPermissionsXHR: s.account.getAccountPermissionsXHR,
        getAccountXHR: s.account.getAccountXHR
    }));

    let isWait = !((
        (eidParam && ['SUCCESS', 'FAILED', 'UPDATED'].includes(event.getEventXHR))
    ) || (
        (![account.getAccountUserPermissionsXHR, account.getAccountPermissionsXHR].includes('LOADING'))
        && (pidParam && ['SUCCESS', 'FAILED', 'UPDATED'].includes(account.getAccountXHR))
    ));

    if(eidParam && event.eid && event.eid !== Number(eidParam)) {
        isWait = true;
    }

    if(pidParam && account.pid && account.pid !== Number(pidParam)) {
        isWait = true;
    }

    return isWait;
};

export default useLoadingState;
